import React, { Component } from 'react';
import ReportHeader from '../../ReportHeader'
import ReportHeader2 from '../../ReportHeader2'
import ReportHeader3 from '../../ReportHeader3'
import Section from '../../ReportSection/index'
  import SpecTable from 'components/display/SpecTable'
import { PCIE_BANDWIDTH_EXCEED } from './constants'
import ErrorTable from '../ErrorTable'
import T from 'i18n-react'
import styles from './styles.scss'
import CSSModules from 'helpers/CSSModulesUtil'
import {
  Table,
    TableHead,
    TableRow,
    TableCell
} from 'react-toolbox'
import SuccessStatus from '../../SuccessStatus/index'
import { connect } from 'react-redux'
import { downloadFiles } from 'containers/Project/NvqualSection/actions'
import { compose } from 'recompose';

const mapDispatchToProps = (dispatch) => {
  return {
      onDownloadFile: (files, name) => dispatch(downloadFiles(files, name))
  }
}

class PexBandwidth extends Component {


    renderAdditionalErrorInformation (errorType, info) {
        if (errorType == 'pcie_bandwidth_expected_greater_than_actual') {
            return (
              PCIE_BANDWIDTH_EXCEED.map(x => {
                    return (
                        <code>{`${T.translate(`containers.project.nvqualSection.errors.pexBandwidthGreaterThanActual.${x}`)}: ${info[x]}`}<br/></code>
                        )
                })
            )
        }
    }

    renderResultTable() {
      const { runs } = this.props.data[0]
      return (
        <Table selectable={false}>
          <TableHead key={`head`}>
            <TableCell key={`device`}>Device</TableCell>
            <TableCell key={`pcieGenSpeed`}>PCIe Gen Speed</TableCell>
            <TableCell key={`bandwidthPercent`}>Bandwidth (%)</TableCell>
            <TableCell key={`bandwidthGbits`}>Bandwidth (Gbit/s)</TableCell>
            <TableCell key={`fbToSys`}>Fb to Sys</TableCell>
            <TableCell key={`sysToFb`}>Sys to Fb</TableCell>
            <TableCell key={`results`}>Results</TableCell>
          </TableHead>
          {runs.map((run, idx) => (
            <TableRow key={idx}>
              <TableCell key={`device${idx}`}>{run.name}</TableCell>
              <TableCell key={`pcieGenSpeed${idx}`}>{run.testingPex}</TableCell>
              <TableCell key={`bandwidthPercent${idx}`}>{run.expectationActual}</TableCell>
              <TableCell key={`bandwidthGbits${idx}`}>{run.avgRawBandwidth}</TableCell>
              <TableCell key={`fbToSys${idx}`}>{run.fbToSysReal}</TableCell>
              <TableCell key={`sysToFb${idx}`}>{run.sysToFbReal}</TableCell>
              <TableCell key={`results${idx}`}>{
                run.expectationResult === true ?
                <code className={styles.green}>Pass</code> : 
                run.expectationResult === false ?
                <code className={styles.red}>Fail</code>:
                <span />
               }</TableCell>
            </TableRow>
          ))}
        </Table>
      )
    }

    render(){
        const { error, data, onDownloadFile, files, testName, testId, result } = this.props
        const hasErrorData = error && error.length > 0

        return(
        <Section>
            <ReportHeader title={T.translate(`containers.project.nvqualSection.test.${testId}`)}
                  showDownload
                  onDownloadClick={onDownloadFile.bind(this, files.map((f) => f.id), testName)}/>
            <Section>
                <ReportHeader2 title={'Summary'} />
                <Section>
                <SuccessStatus result={result} />
                {hasErrorData && 
                  <React.Fragment>
                  <ReportHeader3 title={'Errors'} />
                      <ErrorTable
                          errors={error}
                          errorSpecificRenderFunc={this.renderAdditionalErrorInformation} />
                  </React.Fragment>}
                </Section>
            </Section>
            <Section>
                <ReportHeader2 title={'Test Results'} />
                {this.renderResultTable()}
            </Section>
        </Section>
        );
    }
    }

    const withConnect = connect(null, mapDispatchToProps)
    const withStyles = CSSModules(styles);
    const enhance = compose(withConnect, withStyles);
    export default enhance(PexBandwidth);